import { MyShopActions } from '../actions';

export type MyShopPointOfServiceState = {
  init: boolean;
  name?: string;
};

export const initialState: MyShopPointOfServiceState = {
  init: false,
  name: undefined,
};

export function myShopPointOfServiceReducer(
  state = initialState,
  action: MyShopActions.MyShopPointOfServiceAction,
): MyShopPointOfServiceState {
  switch (action.type) {
    case MyShopActions.SET_MY_SHOP_NAME: {
      return {
        ...state,
        name: action.name,
      };
    }

    case MyShopActions.INIT_MY_SHOP: {
      return {
        ...state,
        init: true,
      };
    }

    default: {
      return state;
    }
  }
}
